/**
 * Inline SVG brand icons for the connection frame.
 * Each renders at brand-accurate colors. No external dependencies.
 */

interface IconProps {
  size?: number;
}

export function GmailIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size}>
      <path
        fill="#4A90E2"
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"
      />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      />
    </svg>
  );
}

export function SlackIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#fff">
      <path d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z" />
    </svg>
  );
}

export function LinkedInIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#fff">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
}

export function GitHubIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#ccc">
      <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0 1 12 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" />
    </svg>
  );
}

export function NotionIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#fff">
      <path d="M4.459 4.208c.746.606 1.026.56 2.428.466l13.215-.793c.28 0 .047-.28-.046-.326L17.86 1.968c-.42-.326-.981-.7-2.055-.607L3.01 2.295c-.466.046-.56.28-.374.466zm.793 3.08v13.904c0 .747.373 1.027 1.214.98l14.523-.84c.841-.046.935-.56.935-1.167V6.354c0-.606-.233-.933-.748-.887l-15.177.887c-.56.047-.747.327-.747.933zm14.337.745c.093.42 0 .84-.42.888l-.7.14v10.264c-.608.327-1.168.514-1.635.514-.748 0-.935-.234-1.495-.933l-4.577-7.186v6.952L12.21 19s0 .84-1.168.84l-3.222.186c-.093-.186 0-.653.327-.746l.84-.233V9.854L7.822 9.76c-.094-.42.14-1.026.793-1.073l3.456-.233 4.764 7.279v-6.44l-1.215-.14c-.093-.514.28-.887.747-.933zM1.936 1.035l13.31-.98c1.634-.14 2.055-.047 3.082.7l4.249 2.986c.7.513.934.653.934 1.213v16.378c0 1.026-.373 1.634-1.68 1.726l-15.458.934c-.98.047-1.448-.093-1.962-.747l-3.129-4.06c-.56-.747-.793-1.306-.793-1.96V2.667c0-.839.374-1.54 1.447-1.632z" />
    </svg>
  );
}

export function SpotifyIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#1DB954">
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.56.3z" />
    </svg>
  );
}

import {
  CalendarIcon,
  ChromeIcon,
  ContactsIcon,
  FinderIcon,
  MailIcon,
  MapsIcon,
  MessagesIcon,
  MusicIcon,
  NotesIcon,
  PhotosIcon,
  PreviewIcon,
  RemindersIcon,
  SafariIcon,
  SystemSettingsIcon,
  TerminalIcon,
  TextEditIcon,
  VSCodeIcon,
} from "./local-app-icons";
import { CliLogo } from "@/components/ui/cli-logo";

/** OpenCode brand mark (shared CLI logo) as an app tile icon. */
function OpenCodeIcon({ size = 22 }: IconProps) {
  return (
    <span
      style={{ width: size, height: size }}
      className="grid place-items-center overflow-hidden"
    >
      <CliLogo cli="opencode" className="h-full w-full" />
    </span>
  );
}

/** Union type for all known app IDs: third-party brand icons + local macOS apps */
export type AppId =
  | "gmail"
  | "slack"
  | "linkedin"
  | "github"
  | "notion"
  | "spotify"
  | "finder"
  | "textedit"
  | "preview"
  | "terminal"
  | "safari"
  | "chrome"
  | "apple-mail"
  | "apple-calendar"
  | "apple-messages"
  | "apple-music"
  | "apple-notes"
  | "apple-reminders"
  | "apple-photos"
  | "apple-contacts"
  | "apple-maps"
  | "system-settings"
  | "vscode"
  | "opencode";

/** Brand background color for each known app */
const APP_BG_MAP: Record<AppId, string> = {
  gmail: "bg-white",
  slack: "bg-[#4A154B]",
  linkedin: "bg-[#0A66C2]",
  github: "bg-[#1a1a1a]",
  notion: "bg-[#1a1a1a]",
  spotify: "bg-[#191414]",
  finder: "bg-[#0A84FF]",
  textedit: "bg-[#8E8E93]",
  preview: "bg-[#5E5CE6]",
  terminal: "bg-[#1C1C1E]",
  safari: "bg-[#1890FF]",
  chrome: "bg-[#EA4335]",
  "apple-mail": "bg-[#007AFF]",
  "apple-calendar": "bg-[#FF3B30]",
  "apple-messages": "bg-[#34C759]",
  "apple-music": "bg-[#FA1744]",
  "apple-notes": "bg-[#FFCC00]",
  "apple-reminders": "bg-[#FF9F0A]",
  "apple-photos": "bg-[#30B0C7]",
  "apple-contacts": "bg-[#5856D6]",
  "apple-maps": "bg-[#00C7BE]",
  "system-settings": "bg-[#8E8E93]",
  vscode: "bg-[#007ACC]",
  opencode: "bg-[#F1ECEC]",
};

/** Display name for each known app */
const APP_NAME_MAP: Record<AppId, string> = {
  gmail: "Gmail",
  slack: "Slack",
  linkedin: "LinkedIn",
  github: "GitHub",
  notion: "Notion",
  spotify: "Spotify",
  finder: "Finder",
  textedit: "TextEdit",
  preview: "Preview",
  terminal: "Terminal",
  safari: "Safari",
  chrome: "Chrome",
  "apple-mail": "Mail",
  "apple-calendar": "Calendar",
  "apple-messages": "Messages",
  "apple-music": "Music",
  "apple-notes": "Notes",
  "apple-reminders": "Reminders",
  "apple-photos": "Photos",
  "apple-contacts": "Contacts",
  "apple-maps": "Maps",
  "system-settings": "Settings",
  vscode: "VS Code",
  opencode: "OpenCode",
};

/** Icon component for each known app */
const APP_ICON_MAP: Record<
  AppId,
  (props: { size?: number }) => React.ReactElement
> = {
  gmail: GmailIcon,
  slack: SlackIcon,
  linkedin: LinkedInIcon,
  github: GitHubIcon,
  notion: NotionIcon,
  spotify: SpotifyIcon,
  finder: FinderIcon,
  textedit: TextEditIcon,
  preview: PreviewIcon,
  terminal: TerminalIcon,
  safari: SafariIcon,
  chrome: ChromeIcon,
  "apple-mail": MailIcon,
  "apple-calendar": CalendarIcon,
  "apple-messages": MessagesIcon,
  "apple-music": MusicIcon,
  "apple-notes": NotesIcon,
  "apple-reminders": RemindersIcon,
  "apple-photos": PhotosIcon,
  "apple-contacts": ContactsIcon,
  "apple-maps": MapsIcon,
  "system-settings": SystemSettingsIcon,
  vscode: VSCodeIcon,
  opencode: OpenCodeIcon,
};

/**
 * Display names for common Composio MCP toolkit slugs without brand icons.
 * MCP connections are per-user dynamic (any catalog slug can appear), so the
 * long tail falls back to a capitalized label + globe icon. These aliases keep
 * the frequent slugs readable (e.g. "googlecalendar" -> "Google Calendar").
 */
const MCP_DISPLAY_NAMES: Record<string, string> = {
  googlecalendar: "Google Calendar",
  googledrive: "Google Drive",
  googlesheets: "Google Sheets",
  googledocs: "Google Docs",
  googleslides: "Google Slides",
  googlecontacts: "Google Contacts",
  googletasks: "Google Tasks",
  outlook: "Outlook",
  onedrive: "OneDrive",
  sharepoint: "SharePoint",
  teams: "Teams",
  linear: "Linear",
  jira: "Jira",
  asana: "Asana",
  trello: "Trello",
  clickup: "ClickUp",
  todoist: "Todoist",
  airtable: "Airtable",
  discord: "Discord",
  zoom: "Zoom",
  salesforce: "Salesforce",
  hubspot: "HubSpot",
  stripe: "Stripe",
  gitlab: "GitLab",
  bitbucket: "Bitbucket",
  figma: "Figma",
  miro: "Miro",
  dropbox: "Dropbox",
  box: "Box",
  twitter: "Twitter",
  facebook: "Facebook",
  instagram: "Instagram",
  youtube: "YouTube",
  tiktok: "TikTok",
  whatsapp: "WhatsApp",
  telegram: "Telegram",
  intercom: "Intercom",
  zendesk: "Zendesk",
  shopify: "Shopify",
};

/**
 * Normalize a free-form app reference to a canonical slug.
 * Desktop tools accept any app name or bundle ID ("Mail", "Apple Mail",
 * "com.apple.mail", "Google Chrome"), so map the common variants. Unknown
 * values (e.g. a user's own Composio slug) pass through lowercased.
 */
export function normalizeAppId(raw: string): string {
  const compact = raw.trim().toLowerCase().replace(/[^a-z0-9]/g, "");
  switch (compact) {
    case "finder":
    case "comapplefinder":
      return "finder";
    case "textedit":
    case "comappletextedit":
      return "textedit";
    case "preview":
    case "comapplepreview":
      return "preview";
    case "terminal":
    case "comappleterminal":
      return "terminal";
    case "safari":
    case "comapplesafari":
      return "safari";
    case "chrome":
    case "googlechrome":
    case "comgooglechrome":
      return "chrome";
    case "mail":
    case "applemail":
    case "comapplemail":
    case "comapplemobilemail":
      return "apple-mail";
    case "calendar":
    case "applecalendar":
    case "comappleical":
    case "comapplemobilecal":
      return "apple-calendar";
    case "messages":
    case "applemessages":
    case "comapplemessages":
    case "comapplemobilesms":
      return "apple-messages";
    case "music":
    case "applemusic":
    case "comapplemusic":
      return "apple-music";
    case "notes":
    case "applenotes":
    case "comapplenotes":
      return "apple-notes";
    case "reminders":
    case "applereminders":
    case "comapplereminders":
      return "apple-reminders";
    case "photos":
    case "applephotos":
    case "comapplemobileslideshow":
      return "apple-photos";
    case "contacts":
    case "applecontacts":
    case "comappleaddressbook":
      return "apple-contacts";
    case "maps":
    case "applemaps":
    case "comapplemaps":
      return "apple-maps";
    case "settings":
    case "systemsettings":
    case "systempreferences":
    case "comapplesystempreferences":
    case "comapplesystemsettings":
      return "system-settings";
    case "vscode":
    case "code":
    case "visualstudiocode":
    case "comvisualstudiocode":
      return "vscode";
    case "opencode":
    case "comopencode":
      return "opencode";
    case "spotify":
    case "comspotifyclient":
      return "spotify";
    default:
      return raw.trim().toLowerCase();
  }
}

function isKnownApp(name: string): name is AppId {
  return Object.prototype.hasOwnProperty.call(APP_ICON_MAP, name);
}

/** Brand art is only available for the apps represented in this map. */
export function getKnownAppIcon(appName: string): ((props: { size?: number }) => React.ReactElement) | null {
  const slug = normalizeAppId(appName);
  return isKnownApp(slug) ? APP_ICON_MAP[slug] : null;
}

/** Capitalize an unknown app name for display (e.g. "my_app" -> "My App") */
function capitalize(name: string): string {
  return name.replace(/[_-]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Get the icon component for an app, with fallback for unknown apps */
export function getAppIcon(
  appName: string,
): (props: { size?: number }) => React.ReactElement {
  const slug = normalizeAppId(appName);
  if (isKnownApp(slug)) return APP_ICON_MAP[slug];
  return FallbackIcon;
}

/** Get the display name for an app, with fallback for unknown apps */
export function getAppName(appName: string): string {
  const slug = normalizeAppId(appName);
  if (isKnownApp(slug)) return APP_NAME_MAP[slug];
  if (MCP_DISPLAY_NAMES[slug]) return MCP_DISPLAY_NAMES[slug];
  return capitalize(appName);
}

/** Get the background class for an app, with fallback for unknown apps */
export function getAppBg(appName: string): string {
  const slug = normalizeAppId(appName);
  if (isKnownApp(slug)) return APP_BG_MAP[slug];
  return "bg-[#333]";
}

/** Fallback icon for apps without a brand SVG */
function FallbackIcon({ size = 22 }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="#999"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  );
}
